import { FC } from 'react'
import classes from './Loader.module.css'

type LoaderProps = {
  show?: boolean
}

export const Loader: FC<LoaderProps> = ({ show }) => {
  return (
    <div className={`${classes.root} ${!show ? classes.hidden : ''}`}>
      <div className={`${classes.loader} app-ldr`}>
        <div className="app-crl app-crl-1">
          <svg className="app-svg" viewBox="22 22 44 44">
            <circle className="app-crl-c" cx="44" cy="44"
                    r="21.5" fill="none" strokeWidth="1"></circle>
          </svg>
        </div>
        <div className="app-crl app-crl-2">
          <svg className="app-svg" viewBox="22 22 44 44">
            <circle className="app-crl-c" cx="44" cy="44"
                    r="21.5" fill="none" strokeWidth=".8"></circle>
          </svg>
        </div>
        <div className="app-crl app-crl-3">
          <svg className="app-svg" viewBox="22 22 44 44">
            <circle className="app-crl-c" cx="44" cy="44"
                    r="21.5" fill="none" strokeWidth=".6"></circle>
          </svg>
        </div>
      </div>
    </div>
  )
}
